import { render, staticRenderFns } from "./AssessmentInterviewQuestionMultiCol.vue?vue&type=template&id=955e78f4&scoped=true&"
import script from "./AssessmentInterviewQuestionMultiCol.vue?vue&type=script&lang=js&"
export * from "./AssessmentInterviewQuestionMultiCol.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentInterviewQuestionMultiCol.vue?vue&type=style&index=0&id=955e78f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955e78f4",
  null
  
)

export default component.exports